import { Component, OnDestroy, OnInit } from '@angular/core';
import { UserService } from '../../../services/user.service';
import { Status } from '../../../models/status.model';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { StepsControllerService } from '../../../services/steps-controller.service';
import { AdminService } from '../../../services/admin.service';
import { StepTempControllerService } from '../../../services/step-temp-controller.service';
import { ConfirmationPopupComponent } from '../../views/view-group/popups/confirmation-popup/confirmation-popup.component';
import { LanguageSwitcher } from '../../../header/language-switcher/language-switcher.model';
import { ViewDocxComponent } from '../../views/view-docx/view-docx.component';
import { ViewDocxService } from '../../../services/view-docx.service';
import {User} from '../../../models/user.model';
import { ConfirmDelete } from '../../../modals/confirmDelete/confirmDelete.component';

import {HttpErrorResponse} from '@angular/common/http';
import {Subject} from 'rxjs/Subject';
import 'rxjs/add/operator/takeUntil';
import {StandardVersionSnapshot, isStandardVersionConflict} from 'app/services/standard-version';
import {clearStandardListPageOnLeave} from 'app/services/standard-list-navigation';

interface StandardListItem extends StandardVersionSnapshot {
  status?: string;
  canEdit?: boolean;
  canManageLifecycle?: boolean;
}
interface StandardListPage { content: StandardListItem[]; totalElements: number; }

const STANDARD_ACTIVE = 'ACTIVE';
const STANDARD_INACTIVE = 'INACTIVE';
const STANDARD_CANCEL_QUESTION = 'CAOTS';
const STANDARD_CANCEL_CONFIRMED = 'ok';
const STANDARD_DELETE_CONFIRMED = 'Delete';
const FIRST_STANDARD_PAGE = 1;
const EMPTY_STANDARD_COUNT = 0;

@Component({
  selector: 'app-operating-standard-list-all',
  templateUrl: './operating-standard-list-all.component.html',
  styleUrls: ['./operating-standard-list-all.component.css']
})
export class OperatingStandardListAllComponent implements OnInit, OnDestroy {
  versionConflict = false;
  reloadFailed = false;
  private destroyed = false;
  private readonly destroyed$ = new Subject<void>();
  noStandardsInfo = true;
  getStandardErrorInfo = false;
  isLoaded = false;
  allStandardList: any;
  sortDirection = true; // false;
  waitTempStandard = false;
  disableAll = false;
  standardNotFound = false;
  currentSortId = 'number,asc';
  withNotification = false;
  errorMessage = false;
  currentSearchValue = '';
  currentPage = 0;
  currentStatus = '';
  clearFilterStatus = '';
  p = localStorage.getItem('lastPage2') ? Number(localStorage.getItem('lastPage2')) : 1; // current page for ngx-pagination
  totalItems = 0; // totalItems for ngx pagination
  private user: User;
  isAdmin = false;
  isHead = false;
  isUser = false;
  userId;

  statusList = ['ACTIVE', 'NEW', 'INACTIVE', 'UNDER_CONFIRMATION', 'UNDER_FAMILIARIZATION', this.clearFilterStatus];


  constructor(private userService: UserService,
    private modalService: NgbModal,
    private adminService: AdminService,
    public viewDocxService: ViewDocxService,
    public stepsControllerService: StepsControllerService,
    private stepTempControllerService: StepTempControllerService,
    public languageSwitcher: LanguageSwitcher) {
    this.userId = JSON.parse(localStorage.getItem('User')).id;
  }

  ngOnInit() {
    this.currentStatus = this.clearFilterStatus;

    // Get All HEAD standards on init
    this.getAllHeadStandardsAPI();
    this.checkRole();
  }

  checkRole() {
    this.user = this.userService.getLocal();
    if (this.user.roles.indexOf('ROLE_HEAD') !== -1) {
      this.isHead = true;
    } else {
      this.isHead = false;
    }
    if (this.user.roles.indexOf('ROLE_ADMIN') !== -1) {
      this.isAdmin = true;
    } else {
      this.isAdmin = false;
    }
    if (this.user.roles.indexOf('ROLE_USER') !== -1) {
      this.isUser = true;
    } else {
      this.isUser = false;
    }
  }

  ngOnDestroy() {
    this.destroyed = true;
    this.destroyed$.next();
    this.destroyed$.complete();
    clearStandardListPageOnLeave();
  }

  getAllHeadStandardsAPI() {
    this.userService.getGroupHeadStandards2().subscribe(
      (standResponse: any) => {
        if (standResponse.status === 200) {
          const res = standResponse.body;
          this.allStandardList = res.content;
          this.totalItems = res.totalElements;
          this.getStandardErrorInfo = false;

          if (this.allStandardList.length > 0) {
            this.noStandardsInfo = false;
          } else {
            this.totalItems = 0;
            this.noStandardsInfo = true;
          }

        } else if (standResponse.status === 204) {
          this.getStandardErrorInfo = false;
          this.noStandardsInfo = true;
          this.isLoaded = true;
        }
      },
      (error) => {
        this.isLoaded = true;
        this.noStandardsInfo = true;
        this.getStandardErrorInfo = true;
        this.isLoaded = true;
      }, () => {
        this.isLoaded = true;
      }
    );
  }

  // Search value
  searchValue(value) {
    this.getStandardsByValue(value.trim());
  }

  getStandardsByValue(value) {
    this.currentStatus = this.clearFilterStatus;
    this.currentSearchValue = value;

    this.userService.getHeadStandardsByValue(value.trim()).subscribe(
      (standResponse: any) => {
        if (standResponse.status === 200) {
          const res = standResponse.body;
          this.allStandardList = res.content;
          this.totalItems = res.totalElements;
          this.getStandardErrorInfo = false;

          if (this.allStandardList.length > 0) {
            this.standardNotFound = false;
          } else {
            this.totalItems = 0;
            this.standardNotFound = true;
          }

        } else if (standResponse.status === 204) {
          this.getStandardErrorInfo = false;
          this.noStandardsInfo = true;
          this.isLoaded = true;
        }
      },
      (error) => {
        this.isLoaded = true;
        this.noStandardsInfo = true;
        this.getStandardErrorInfo = true;
        this.isLoaded = true;
      }, () => {
        this.isLoaded = true;
      }
    );

  }

  // FILTER LIST BY STATUS
  filterByStatus(status) {
    if (status === this.clearFilterStatus) {
      this.clearAllFilter();
    } else {
      this.currentStatus = status;
      this.getFilteredFromAPI();
    }
  }

  getFilteredFromAPI() {
    this.userService.getFilteredHeadStandards(this.currentSearchValue.trim(), this.currentStatus).subscribe(
      (standResponse: any) => {
        if (standResponse.status === 200) {
          const res = standResponse.body;
          this.allStandardList = res.content;
          this.totalItems = res.totalElements;
          this.getStandardErrorInfo = false;

          if (this.allStandardList.length > 0) {
            this.standardNotFound = false;
          } else {
            this.totalItems = 0;
            this.standardNotFound = true;
          }

        } else if (standResponse.status === 204) {
          this.getStandardErrorInfo = false;
          this.noStandardsInfo = true;
          this.isLoaded = true;
        }
      },
      (error) => {
        this.isLoaded = true;
        this.noStandardsInfo = true;
        this.getStandardErrorInfo = true;
        this.isLoaded = true;
      }, () => {
        this.isLoaded = true;
      }
    );

  }

  clearAllFilter() {
    this.currentStatus = this.clearFilterStatus;
    this.getFilteredFromAPI();
  }

  // Get page
  getPage(page: number) {
    this.getPageAPIHead(page);
  }

  // Get page from API
  getPageAPIHead(pageNumber: number) {
    const page = pageNumber - 1;
    localStorage.setItem('lastPage2', pageNumber.toString());
    this.userService.getPageAPIHead2(this.currentSearchValue.trim(), page, this.currentStatus, this.currentSortId).subscribe(
      (standResponse: any) => {
        if (standResponse.status === 200) {
          const res = standResponse.body;
          this.allStandardList = res.content;
          this.totalItems = res.totalElements;
          this.p = pageNumber;
          this.getStandardErrorInfo = false;

          if (this.allStandardList.length > 0) {
            this.standardNotFound = false;
          } else {
            this.totalItems = 0;
            this.standardNotFound = true;
          }

        } else if (standResponse.status === 204) {
          this.getStandardErrorInfo = false;
          this.noStandardsInfo = true;
          this.isLoaded = true;
        }
      },
      (error) => {
        this.isLoaded = true;
        this.noStandardsInfo = true;
        this.getStandardErrorInfo = true;
        this.isLoaded = true;
      }, () => {
        this.isLoaded = true;
      }
    );
  }

  // SORT LIST BY sortId // // // // // //
  // sortId values:
  // 'number, asc' is using by default
  // 'number,asc' or 'number,desc'
  // 'ruName,asc' or 'ruName,desc'
  // 'enName,asc' or 'enName,desc'
  // 'ruType,asc' or 'ruType,desc'
  // 'enType,asc' or 'enType,desc'
  // 'status,asc' or 'status,desc'
  // // // // // // // // // // // // //
  sortList(sortId) {

    if (this.sortDirection) {
      sortId += ',desc';
      this.sortDirection = !this.sortDirection;
      this.currentSortId = sortId;
    } else {
      sortId += ',asc';
      this.sortDirection = !this.sortDirection;
      this.currentSortId = sortId;
    }
    this.getSortedHListAPI(sortId);

  }

  // GET SORDET LIST FROM API
  getSortedHListAPI(sortId) {
    const pageNumb = this.p - 1;
    this.userService.getSortedHeadList(pageNumb, sortId, this.currentSearchValue.trim(), this.currentStatus).subscribe(
      (standResponse: any) => {
        if (standResponse.status === 200) {
          const res = standResponse.body;
          this.allStandardList = res.content;
          this.totalItems = res.totalElements;
          this.getStandardErrorInfo = false;

          if (this.allStandardList.length > 0) {
            this.standardNotFound = false;
          } else {
            this.totalItems = 0;
            this.standardNotFound = true;
          }

        } else if (standResponse.status === 204) {
          this.getStandardErrorInfo = false;
          this.noStandardsInfo = true;
          this.isLoaded = true;
        }
      },
      (error) => {
        this.isLoaded = true;
        this.noStandardsInfo = true;
        this.getStandardErrorInfo = true;
        this.isLoaded = true;
      }, () => {
        this.isLoaded = true;
      }
    );
  }

  setStyle(standardStatus) {
    let style = {};
    // active - #e3ffdf
    // inactive - #ffdcd8
    // confirmed - #aff2ab
    // needfix - #f2ddb9
    // timeout - #f29a9b
    // canceled - #9e9b9a
    if (standardStatus === 'ACTIVE') {
      style = { 'background-color': 'none !important;' };
      // style = {'background-color': '#e3ffdf'}
    } else if (standardStatus === 'INACTIVE') {
      style = { 'background-color': '#ffdcd8 !important;' };
    } else if (standardStatus === 'CONFIRMED !important;') {
      style = { 'background-color': '#aff2ab' };
    } else if (standardStatus === 'NEEDFIX !important;') {
      style = { 'background-color': '#f2ddb9 !important;' };
    } else if (standardStatus === 'TIMEOUT') {
      style = { 'background-color': '#f29a9b !important;' };
    } else if (standardStatus === 'CANCELED') {
      style = { 'background-color': '#989594 !important;' };
    } else if (standardStatus === null) {
      style = { 'background-color': 'none !important;' };
    }
    return style;
  }


  getGBigStandardByID(sID, action) {
    let bigStandard = null;
    this.adminService.getStandard(sID).subscribe(
      (res: any) => {
        if (res.status === 200) {
          bigStandard = res.body;
          switch (action) {
            case 'standardDbClick':
              this.simpleOpenStandard(bigStandard);
              break;
            // case 'editThisStandard':
            //   this.waitTempStandard = true;
            //   this.stepsControllerService.setEditActive(true);
            //   this.stepsControllerService.setEditActiveWithNotification(false);
            //   this.setTempStandardForEditing(bigStandard);
            //   break;
            case 'editThisStandardWithNotification':
              this.waitTempStandard = true;
              this.stepsControllerService.setEditActive(false);
              this.stepsControllerService.setEditActiveWithNotification(true);
              this.withNotification = true;
              this.setTempStandardForEditing(bigStandard.id);
              break;
          }
          this.disableAll = false;
        } else {
          this.disableAll = false;
        }
      },
      () => {
        this.disableAll = false;
      }
    );
  }

  standardDbClick(standardID) {
    this.getGBigStandardByID(standardID, 'standardDbClick');
  }

  editThisStandard(standard: StandardListItem) {
    if (!standard || standard.canEdit !== true) { return; }
    this.withNotification = false;
    this.disableAll = true;
    this.setTempStandardForEditing(standard.id);
  }


  openDocModal(docxID, sID) {

    localStorage.setItem('DocxID', docxID);
    localStorage.setItem('DocxSID', sID);

    const modalRef = this.modalService.open(ViewDocxComponent, { size: 'lg', backdrop: 'static' });
    modalRef.result.then((result) => {
      if (result === 'Close') {
        // on close button
        this.viewDocxService.deleteLinkByDocxID();
      }
    }, (reason) => {
      // on dismiss
      this.viewDocxService.deleteLinkByDocxID();
    });

  }


  openDocModalDOCX(fileLink) {
    localStorage.setItem('fileLink', fileLink);

    const modalRef = this.modalService.open(ViewDocxComponent, { size: 'lg', backdrop: 'static' });
    modalRef.result.then((result) => {
      if (result === 'Close') {
        // on close button
        this.viewDocxService.deleteLinkByDocxIDManually();
      }
    }, (reason) => {
      // on dismiss
      this.viewDocxService.deleteLinkByDocxIDManually();
    });
  }



  openPdf(fileId: string) {
    this.userService.getPdf(fileId).subscribe(
      (response: any) => {
        const fileURL = window.URL.createObjectURL(new Blob([response.body], { type: 'application/pdf' }));
        window.open(fileURL, '_blank');
      }
    );
  }

  downloadFile(fileId: string) {
    this.userService.getFile(fileId).subscribe(
      (response: any) => {
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(response.body);
        link.download = response.headers.get('filename');
        link.click();
        link.remove();
      },
      () => {
      }
    );
  }

  editThisStandardWithNotification(standardID) {
    this.disableAll = true;
    this.getGBigStandardByID(standardID, 'editThisStandardWithNotification');
  }

  setTempStandardForEditing(id) {
    this.waitTempStandard = true;
    this.stepsControllerService.setEditActive(!this.withNotification);
    this.stepsControllerService.setEditActiveWithNotification(this.withNotification);

    this.adminService.getTempStandard(id).subscribe(
      (res: any) => {
        if (res.status === 200) {
          const tmpStnd = res.body;
          tmpStnd.status = 'ON_EDITING';
          this.stepsControllerService.activeStep = 8;
          this.stepsControllerService.setTempParrentID(id);
          this.stepsControllerService.setCurrentStandard(tmpStnd);
          this.waitTempStandard = false;
        }
      },
      () => {
        this.waitTempStandard = false;
      }
    );
  }

  cancelThisStandard(standard: StandardListItem): void {
    if (!this.beginStandardAction()) { return; }
    const snapshot = Object.assign({}, standard);
    const modal = this.modalService.open(ConfirmationPopupComponent);
    modal.componentInstance.massage = STANDARD_CANCEL_QUESTION;
    modal.result.then(result => {
      if (result !== STANDARD_CANCEL_CONFIRMED || this.destroyed) { this.disableAll = false; return; }
      this.deactivateStandard(standard, snapshot);
    }, () => { this.disableAll = false; });
  }

  private deactivateStandard(standard: StandardListItem, snapshot: StandardVersionSnapshot): void {
    const originalVersion = snapshot.version;
    this.adminService.changeStatusDeactivate(snapshot).takeUntil(this.destroyed$).subscribe(() => {
      this.acceptStatusChange(standard, { version: originalVersion, saved: snapshot.version }, STANDARD_INACTIVE);
    }, error => this.rejectStandardAction(error));
  }

  simpleOpenStandard(standard) {
    this.stepsControllerService.setCurrentStandard(standard);
  }

  activateStandard(standard: StandardListItem): void {
    if (!standard || standard.canManageLifecycle !== true) { return; }
    if (!this.beginStandardAction()) { return; }
    const snapshot = Object.assign({}, standard);
    const originalVersion = snapshot.version;
    this.adminService.changeStatusToActive(snapshot, STANDARD_ACTIVE).takeUntil(this.destroyed$).subscribe(() => {
      this.acceptStatusChange(standard, { version: originalVersion, saved: snapshot.version }, STANDARD_ACTIVE);
    }, error => this.rejectStandardAction(error));
  }

  private acceptStatusChange(standard: StandardListItem, versions: { version: number; saved: number }, status: string): void {
    if (standard.version === versions.version) {
      standard.status = status;
      standard.version = versions.saved;
    }
    this.disableAll = false;
  }

  deleteThisStandard(standard: StandardListItem): void {
    if (!this.beginStandardAction()) { return; }
    const snapshot = Object.assign({}, standard);
    this.modalService.open(ConfirmDelete).result.then(result => {
      if (result !== STANDARD_DELETE_CONFIRMED || this.destroyed) { this.disableAll = false; return; }
      this.userService.deleteStandard(snapshot).takeUntil(this.destroyed$).subscribe(() => {
        this.disableAll = false;
        this.reloadStandardList();
      }, error => this.rejectStandardAction(error));
    }, () => { this.disableAll = false; });
  }

  private beginStandardAction(): boolean {
    if (this.disableAll || this.waitTempStandard || this.versionConflict || this.destroyed) { return false; }
    this.disableAll = true;
    this.errorMessage = false;
    return true;
  }

  private rejectStandardAction(error: HttpErrorResponse): void {
    this.disableAll = false;
    this.versionConflict = isStandardVersionConflict(error);
    this.errorMessage = !this.versionConflict;
  }

  reloadStandardList(): void {
    if (this.disableAll || this.destroyed) { return; }
    this.disableAll = true;
    this.reloadFailed = false;
    const page = Math.max(this.p, FIRST_STANDARD_PAGE) - FIRST_STANDARD_PAGE;
    this.userService.getPageAPIHead2(this.currentSearchValue.trim(), page, this.currentStatus, this.currentSortId)
      .takeUntil(this.destroyed$).subscribe(response => {
        this.acceptReloadedList(response.body as StandardListPage);
      }, () => {
        this.disableAll = false;
        this.reloadFailed = true;
      });
  }

  private acceptReloadedList(page: StandardListPage): void {
    this.allStandardList = page ? page.content : [];
    this.totalItems = page ? page.totalElements : EMPTY_STANDARD_COUNT;
    this.standardNotFound = !this.allStandardList.length;
    this.noStandardsInfo = !this.totalItems;
    this.getStandardErrorInfo = false;
    this.versionConflict = this.errorMessage = false;
    this.disableAll = false;
    this.isLoaded = true;
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/admin/operating-standard-list-all/operating-standard-list-all.component.ts